<template>
	<div class="container member-chain-form">
		<div class="common-header-wrap">
			<mt-header :title="getTitle" class="common-header">
				<mt-button slot="left" icon="back" @click="goBack"></mt-button>
			</mt-header>
		</div>

		<mt-field label="اسم" v-model="address_info.address_realname"></mt-field>
		<mt-field label="الهاتف الخلوي" v-model="address_info.address_mob_phone"></mt-field>
		<mt-cell title="منطقة">
			<div @click="onRegion">
				<span v-if="address_info.area_info">{{address_info.area_info}}</span>
				<span v-else>الرجاء تحديد المنطقة</span>
				<span class="iconfont right-arrow">&#xe600;</span>
			</div>
		</mt-cell>
		<mt-cell title="نقطة جمع" class="address-line-wrapper">
			<div @click="showChain=true">
				<span v-if="address_info.address_detail">{{address_info.address_detail}}</span>
				<span v-else>الرجاء تحديد نقطة تجميع</span>
				<span class="iconfont right-arrow">&#xe600;</span>
			</div>
		</mt-cell>
		<mt-cell title="العنوان الافتراضي"><mt-switch v-model="address_info.address_is_default"></mt-switch></mt-cell>
		<mt-button class="ds-button-large mt-10" type="primary" v-on:click="submit">{{getSumitTitle}}</mt-button>
		<region-picker ref="picker" v-on:onConfirm="onPickerConfirm"></region-picker>
		<mt-popup v-model="showChain" position="right" class="common-popup-wrapper">
			<div class="common-header-wrap">
				<mt-header title="قائمة نقاط التحصيل" class="common-header">
					<mt-button slot="left" icon="back" @click="showChain=false"></mt-button>
				</mt-header>
			</div>
			<div class="common-popup-content">
				<div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
					<div v-if="chainList && chainList.length">
						<div class="top-wrapper" v-for="(item,index) in chainList" :key="index" @click="setChain(item)">
							<div class="title-wrapper">
								<label class="title">{{ item.chain_addressname }}</label>
								<label class="title">{{ item.chain_mobile }}<span v-if="item.chain_telephony">{{ item.chain_telephony }}</span></label>
							</div>
							<label class="desc address-text" style="-webkit-box-orient:vertical">{{item.chain_area_info}}&nbsp;{{item.chain_address}}</label>
							<div class="bottom-line"></div>
						</div>
					</div>
					<empty-record v-else-if="chainList && !chainList.length"></empty-record>
				</div>
			</div>
		</mt-popup>
	</div>
</template>

<script>
import { getPointByAddress } from '../../../util/bmap'
import { Toast, Indicator } from 'mint-ui'
import RegionPicker from '../../../components/RegionPicker'
import EmptyRecord from '../../../components/EmptyRecord'
import { getAddressInfo, addChain, getChainList } from '../../../api/memberAddress'
export default {
  components: {
    RegionPicker,
    EmptyRecord
  },
  computed: {
    isAddMode () {
      let mode = this.$route.query.action
      // add: 添加地址，edit: 编辑地址
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return 'اضف عنوان'
      } else {
        return 'تعديل عنوان التسليم'
      }
    },
    getSumitTitle () {
      let isFromCheckout = this.$route.query.isFromCheckout
      if (isFromCheckout) {
        return 'احفظ واستخدم'
      } else {
        return 'حفظ'
      }
    }
  },
  data () {
    return {
      chainList: [],
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      showChain: false,
      popMap: false,
      address_id: 0,
      address_info: {
		  address_is_default: true
      }
    }
  },
  created: function () {
    if (!this.isAddMode) {
      this.address_id = this.$route.query.address_id
      getAddressInfo(this.address_id).then(res => {
        this.address_info = res.result.address_info

        if (res.result.address_info.address_is_default === '1') {
          this.address_info.address_is_default = true
        } else {
          this.address_info.address_is_default = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  methods: {
    loadMore () {
      if (this.loading) {
        return
      }

      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = true
        this.getChainList(true)
      }
    },
    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.chainList = false
      this.loadMore()
    },
    getChainList () {
      getChainList(this.params, this.address_info.area_id).then(res => {
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
        if (this.chainList) {
          this.chainList = this.chainList.concat(res.result.chain_list)
        } else {
          this.chainList = res.result.chain_list
        }
        this.loading = false
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
        this.loading = false
      })
    },
    setChain (item) {
      this.address_info.chain_id = item.chain_id
      this.address_info.address_detail = item.chain_address
      this.showChain = false
      this.$forceUpdate()
    },
    goBack () {
      this.$router.go(-1)
    },
    getPosition () {
      getPointByAddress(this.address_info.area_info + this.address_info.address_detail).then(res => {
        if (res.result.location) {
          this.address_info.address_longitude = res.result.location.lng
          this.address_info.address_latitude = res.result.location.lat
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    setPosition (lat, lng, name) {
      this.popMap = false
      this.address_info.address_detail = name
      this.address_info.address_longitude = lng
      this.address_info.address_latitude = lat
    },
    submit () {
      if (this.address_info.address_realname === '') {
        Toast('يرجى ملء اسم المستلم')
        return
      }
      if (this.address_info.address_realname.length === 0) {
        Toast('يرجى ملء اسم المستلم')
        return
      }
      if (this.address_info.address_realname.length < 2 || this.address_info.address_realname.length > 15) {
        Toast('عدد الأحرف المسموح به من 2 إلى 15 حرفًا')
        return
      }
      if (this.address_info.address_mob_phone === '') {
        Toast('يرجى ملء رقم الهاتف الخليوي')
        return
      }
      if (this.address_info.address_mob_phone.length === 0) {
        Toast('يرجى ملء رقم الهاتف الخليوي')
        return
      }
      if (this.address_info.area_id === 0 || this.address_info.area_id === undefined) {
        Toast('الرجاء تحديد المنطقة')
        return
      }
      if (this.address_info.chain_id === 0 || this.address_info.chain_id === undefined) {
        Toast('الرجاء تحديد نقطة تجميع')
        return
      }

      addChain(this.address_info).then(
        (response) => {
          Indicator.close()
          this.updateSelectedAddress()
        }, (error) => {
          Indicator.close()
          Toast(error.message)
        })
    },
    onRegion (picker, values) {
      this.$refs.picker.currentValue = true
    },
    onPickerConfirm (values) {
      if (this.address_info.area_id != values[2].area_id) {
        this.address_info.chain_id = 0
        this.address_info.address_detail = ''
      }
      this.address_info.area_info = this.getRegionStr(values)

      this.address_info.area_id = values[2].area_id
      this.address_info.city_id = values[1].area_id
      this.reload()
      this.$forceUpdate()
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    updateSelectedAddress () {
		this.$router.go(-2)
    }
  }
}
</script>
<style lang="scss">
	.member-chain-form .address-line-wrapper .mint-cell-title{flex:unset;width: 5rem}
	.member-chain-form .address-line-wrapper .mint-cell-value{flex:1;text-align: right;    display: block;}
</style>
<style lang="scss" scoped>
	.right-arrow{transform: rotate(-90deg);color:#ddd;font-size: .6rem;display: inline-block;}
	.input-wrap{position: relative;
		i{position: absolute;right:0;top:0;line-height: 2.4rem;display: block;width:2rem;text-align: center;font-size: 1rem}
	}
	.top-wrapper {
		position: relative;
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
	}
	.top-wrapper .title-wrapper {
		height:1rem;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		margin-top:0.5rem;
		margin-left:0.5rem;
	}
	.top-wrapper .title {
		font-size:0.8rem;
		color: #333;
		margin-left:0.5rem;
	}
	.top-wrapper .desc {
		color: #7c7f88;
		font-size: 0.7rem;
	}
	.top-wrapper .address-text {
		margin-top:0.5rem;
		margin-bottom:0.5rem;
		margin-left:1rem;
		margin-right:0.5rem;
	}
	.top-wrapper .bottom-line {
		position: absolute;
		height: 1px;
		left:0.5rem;
		bottom: 0;
		right:0.5rem;
		background-color: #e8eaed;
	}
	.address-line{display: inline-block;max-width: 50%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap}
</style>
